import { ChangeEventHandler, Reducer, useReducer } from 'react';
import { Moment, MomentInput } from 'moment';
import { useLocation } from 'react-router-dom';
import { PLANS } from '~/src/usersite/constants/routing';
import {
  getInitialState,
  reducer,
  ACTION_TYPE,
  Action,
  State,
} from './reducer';

interface Return {
  state: State;
  handleChangeSearchForm: ChangeEventHandler;
  handleChangeSearchTerm: (data: {
    startDate: MomentInput;
    endDate: Moment;
  }) => void;
  resetSearchForm: () => void;
  doSearch: () => void;
}
const useSearchForm = (): Return => {
  const { pathname, search } = useLocation();
  // 募集一覧ページにいる場合にのみ、クエリパラメータを引き継ぐ
  const urlSearchParams = new URLSearchParams(
    pathname.includes(PLANS) ? search : '',
  );

  const [state, dispatch] = useReducer<Reducer<State, Action>>(
    reducer,
    getInitialState(urlSearchParams),
  );

  const handleChangeSearchForm = (event) => {
    const { name, value } = event.target;
    dispatch({
      type: ACTION_TYPE.SET_SEARCH_FORM,
      payload: {
        ...state,
        [name]: value,
      },
    });
  };
  const handleChangeSearchTerm = (data: {
    startDate: MomentInput;
    endDate: MomentInput;
  }) => {
    dispatch({
      type: ACTION_TYPE.SET_SEARCH_FORM,
      payload: {
        ...state,
        startDate: data.startDate as string,
        endDate: data.endDate as string,
      },
    });
  };
  const resetSearchForm = () => {
    dispatch({
      type: ACTION_TYPE.RESET_SEARCH_FORM,
      payload: {},
    });
  };
  const doSearch = () => {
    Object.entries(state).forEach(([key, value]) => {
      if (!value) {
        urlSearchParams.delete(key);
        return;
      }

      urlSearchParams.set(key, value);
      return;
    });

    window.location.href = `${PLANS}?${urlSearchParams.toString()}`;
  };

  return {
    state,
    handleChangeSearchForm,
    handleChangeSearchTerm,
    resetSearchForm,
    doSearch,
  };
};

export default useSearchForm;
